$(function () {
	/*
	* 入力画面の遷移
	*/
	let q1_answer = '', q2_answer = '';
	$('.js-input-content input').on('change', function () {
		$(this).parents('.js-input-content').removeClass('is-show').hide();

		if ($(this).parents('.js-input-content').hasClass('js-q-01')) {
			q1_answer = $(this).val();
			$('.js-q-02').fadeIn().addClass('is-show');

			if (q1_answer === 'VIO') {
				$('.not-vio').hide();
			} else {
				$('.vio').hide();
			}
		}

		if ($(this).parents('.js-input-content').hasClass('js-q-02')) {
			q2_answer = $(this).val();
			$('.js-q-03').fadeIn().addClass('is-show');
			$('.check_input_list li').hide();

			if (q1_answer === '顔' && q2_answer === 'カミソリ') {
				$('.js-q-03 .face').show();
			} else if (q1_answer === 'ボディ' && q2_answer === 'カミソリ') {
				$('.js-q-03 .body01').show();
			} else if (q1_answer === 'ボディ' && q2_answer === 'シェービング剤') {
				$('.js-q-03 .body02').show();
			} else {
				$('body').addClass('is-submit');
				$('#check_form').submit();
			}
		}

		if ($(this).parents('.js-input-content').hasClass('js-q-03')) {
			$('body').addClass('is-submit');
			$('#check_form').submit();
		}
	});

	/*
	* ブラウザバックで入力画面に戻った時に同じ選択肢がクリックできなくなるので対策
	*/
	window.addEventListener('pageshow', function (event) {
		let entries = performance.getEntriesByType('navigation');
		entries.forEach(function (entry) {
			if (entry.type == 'back_forward') {
				location.replace(location.href);
			}
		});
		if (event.persisted) {
			location.replace(location.href);
		}
	});

	/*
	* 結果画面のアイテム条件分岐
	*/
	const query_string = window.location.search;
	const params = new URLSearchParams(query_string);
	const q01_result = params.get('q01');
	const q02_result = params.get('q02');
	const q03_result = params.get('q03');

	if (q01_result === '顔' && q02_result === 'カミソリ') {
		if (q03_result === 'ワンランク上の製品で角質までケアしたい') {
			$('.js-result-item01').addClass('is-show');
		} else if (q03_result === '手軽にうぶ毛をケアしたい') {
			$('.js-result-item02').addClass('is-show');
		} else if (q03_result === 'コスパ重視の製品を使いたい') {
			$('.js-result-item03').addClass('is-show');
		}
	} else if (q01_result === '顔' && q02_result === 'シェービング剤') {
		$('.js-result-item04').addClass('is-show');
	} else if (q01_result === 'ボディ' && q02_result === 'カミソリ') {
		if (q03_result === 'ワンランク上の製品で角質までケアしたい') {
			$('.js-result-item05').addClass('is-show');
		} else if (q03_result === 'うるおいながら体毛ケアしたい') {
			$('.js-result-item06').addClass('is-show');
		} else if (q03_result === '初心者でも使いやすい') {
			$('.js-result-item07').addClass('is-show');
		}
	} else if (q01_result === 'ボディ' && q02_result === 'シェービング剤') {
		if (q03_result === 'エマルジョンタイプでしっとり保湿') {
			$('.js-result-item08').addClass('is-show');
		} else if (q03_result === 'ジェルタイプでさっぱり保湿') {
			$('.js-result-item09').addClass('is-show');
		}
	} else if (q01_result === 'VIO' && q02_result === 'シェーバー') {
		$('.js-result-item10').addClass('is-show');
	} else if (q01_result === 'VIO' && q02_result === 'アフターケア') {
		$('.js-result-item11').addClass('is-show');
	} else {
		$('.js-result-item01').addClass('is-show');
	}
});